import { useQuery } from '@tanstack/react-query';
import { getProjectTemplates, getProjectTemplateTdm } from '../../../api/Sherpa/ProjectTemplate';
import { SherpaProjectReactQueryKey } from '../../../constants/ReactQueryKeys';
import type { QueryParamsInterface } from '../../../types/Shared';

interface ProjectTemplatesHookProps {
  params?: QueryParamsInterface;
  onSuccess?: (data: any) => void;
  onError?: (data: any) => void;
}

export const useProjectTemplates = ({ params, onSuccess, onError }: ProjectTemplatesHookProps) => {
  //Tanstack: version 5 query implementation
  return useQuery({
    queryKey: [SherpaProjectReactQueryKey.GET_PROJECT_TEMPLATES, params],
    queryFn: () => getProjectTemplates({ params }),
    onSuccess,
    onError,
    keepPreviousData: true,
    staleTime: 30000,
  });
};

interface ProjectTemplateTdmHookProps {
  templateId: number;
  params?: QueryParamsInterface | undefined;
  onSuccess?: (data: any) => void;
  onError?: (data: any) => void;
}

export const useProjectTemplateTdm = ({ templateId, params, onSuccess, onError }: ProjectTemplateTdmHookProps) => {
  //Tanstack: version 5 query implementation
  return useQuery({
    queryKey: ['get-project-template-tdm', params, templateId],
    queryFn: () => getProjectTemplateTdm({ templateId, params }),
    onSuccess,
    onError,
    keepPreviousData: true,
    staleTime: 30000,
  });
};
